export default __webpack_public_path__ + "static/media/4.fe2105b3.png";